import { PREFERENCES } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const PreferencesExporter = createExporter(`administration_${PREFERENCES}.xlsx`,
    [
        { key: "nameBg", label: "име на български" },
        { key: "nameEn", label: "име на английски" },
        { key: "isZvo", label: "заявява се при кандидатстване" },
        { key: "isActive", label: "активна" },
    ],
    (record) => ({
        ...record,
        isZvo: record.isZvo ? "Да" : "Не",
        isActive: record.isActive ? "Да" : "Не"
    })
); 